import request from '@/modules/base/util/request'
import accountConfig from '@/modules/account/config'

class BankingService {
  checkIban(iban) {
    const cleanIban = iban?.replace(/\s/gm, '')
    return request(accountConfig.endpoints.checkIban(cleanIban))
  }
}

export default new BankingService()
